function removeProperty(prop, excludedValue) {
  excludedValue.forEach(function (value) {
    delete prop[value];
  });
}

export { removeProperty };
